import React, { VFC } from 'react'
import { NotFoundUi } from './NotFound.ui'

export const NotFound: VFC = () => {
  return <NotFoundUi />
}
